import { Component, OnInit } from '@angular/core';
import { AstrolyticsService } from "../../_services/astrolytics.service"
import { Subscription } from "rxjs";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-seller-search-page',
  templateUrl: './seller-search-page.component.html',
  styleUrls: ['./seller-search-page.component.css']
})
export class SellerSearchPageComponent implements OnInit {

  protected searchQuery
  protected searchResults
  protected loading

  private sellerSearchSubscription: Subscription;

  constructor(private astrolyticsService: AstrolyticsService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.loading = false
    this.searchQuery = this.route.snapshot.queryParamMap.get("q") ? this.route.snapshot.queryParamMap.get("q") : ""

    this.sellerSearchSubscription = this.astrolyticsService.sellerSearchObservable.subscribe((response) => {
      this.loading = false
      if (response) {
        response.sort((a,b) => {return this.compareSellerReputation(a,b)})
        this.searchResults = response
      } else {
        this.searchResults = []
      }
    })

    if (this.searchQuery) {
      this.performSearch()
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.sellerSearchSubscription.unsubscribe()
  }

  performSearch() {
    this.loading = true
    this.searchResults = []

    this.astrolyticsService.searchSellers(this.searchQuery)
  }

  getSellerReputationEmoji(sellerStatus) {
    switch (sellerStatus) {
      case "silver":
        return "🥈 Plata"
      case "gold":
        return "🥇 Oro"
      case "platinum":
        return "🏆 Platino"
      default:
        return "Comun"
    }
  }

  compareSellerReputation(sellerA, sellerB) {
    return this.getSellerReputationValue(sellerA) - this.getSellerReputationValue(sellerB)
  }

  getSellerReputationValue(seller) {
    switch (seller.seller_reputation.power_seller_status) {
      case "silver":
        return 2
      case "gold":
        return 1
      case "platinum":
        return 0
      default:
        return 3
    }
  }
}
